<template>
    <div class="centering_container">
        <div class="main_container">
            <slot></slot>
        </div>
    </div>
</template>

<style scoped>
.centering_container {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
}

.main_container {
    background-color: var(--header);
    box-shadow: 0px 10px 20px var(--header);
    border: var(--border);

    width: 400px;
    min-height: 400px;
    max-height: 600px;
    padding: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
}
</style>
